import { all, take, put, race, select } from 'redux-saga/effects'
import _ from 'lodash'
import { SUCCESS, FAILED } from 'crom-api-constants'

import { changeGroupNameRequest, changeEntityStackGroupData, toggleGroupStack } from '../actions'

import { CHANGE_GROUP_NAME_REQUEST } from '../constants'
import { CONFIRM_DIALOG_ON_BUTTON_CLICK } from '../../../../../components/Dialog/components/Confirm/constants'

import { openDialog } from '../../../../../services/dialog/actions'
import { closePortfolioById } from '../../../scenes/Portfolio/actions'

import { isPortfolioOpen, getPortfolioNameById } from '../../../scenes/Portfolio/selectors'

const dataPath = 'response.success.payload.response.body'

export default function* changeGroupNameSaga(_action) {
    const {
        data: { groupName, groupId },
    } = _action

    const isOpen = yield select(isPortfolioOpen, groupId)

    if (isOpen) {
        const name = yield select(getPortfolioNameById, groupId)

        const dialogSettings = {
            header: { textId: 'portfolio', icon: '' },
            question: { textId: 'portfolioGroupRenamed', values: { name } },
            buttons: ['ok', 'cancel'],
        }

        const userAnswer = yield all({
            answer: race({
                cancel: take(CONFIRM_DIALOG_ON_BUTTON_CLICK('cancel', groupId)),
                ok: take(CONFIRM_DIALOG_ON_BUTTON_CLICK('ok', groupId)),
            }),
            dialog: put(openDialog('confirm', groupId, dialogSettings)),
        })

        if (userAnswer.answer.cancel) {
            yield put(toggleGroupStack(null))
            return null
        }

        yield put(closePortfolioById(groupId, false))
    }

    const result = yield all({
        response: race({
            success: take(`${CHANGE_GROUP_NAME_REQUEST}_${SUCCESS}`),
            failed: take(`${CHANGE_GROUP_NAME_REQUEST}_${FAILED}`),
        }),
        request: put(changeGroupNameRequest(groupName, groupId)),
    })

    const data = _.get(result, dataPath)

    yield put(changeEntityStackGroupData(data))

    return null
}
